"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvValue = exports.getEnv = void 0;
const Logger_1 = require("./Logger");
const error_1 = require("./error");
const dotenv_1 = __importDefault(require("dotenv"));
dotenv_1.default.config();
function getEnv(key, enforced = true, defaultVal) {
    var _a;
    const variable = process.env[key];
    if (!variable) {
        if (enforced) {
            Logger_1.logger.crit({
                message: 'Missing env variable is required. Terminating...',
                cause: key,
                stack: (0, error_1.getStackTrace)(),
            });
            process.exit(1);
        }
        else {
            Logger_1.logger.info({
                message: 'Using default env variable value',
                data: {
                    key,
                    defaultVal,
                },
            });
            return (_a = defaultVal === null || defaultVal === void 0 ? void 0 : defaultVal.toString()) !== null && _a !== void 0 ? _a : undefined;
        }
    }
    else {
        return variable;
    }
}
exports.getEnv = getEnv;
function getEnvValue(key, enforced = true, defaultVal) {
    return getEnv(key, enforced, defaultVal);
}
exports.getEnvValue = getEnvValue;
